import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import Editor from '@tinymce/tinymce-vue'

export default {
    name: 'PrivacyPolicy',
    created,
    data,
    methods,
    components: {
        editor: Editor
    }
}
